<template>
  <v-card class="pa-4 border-radius-lg" flat>
    <div v-if="loading">
      <v-progress-linear indeterminate color="primary"></v-progress-linear>
    </div>
    <v-alert v-if="error" type="error" dismissible>{{ error }}</v-alert>
    <div v-else-if="trialBalanceHtml" v-html="trialBalanceHtml"></div>
  </v-card>
</template>

<script>
import { GLAccountService } from "@/services/gl-account-service.js";

export default {
  name: "TrialBalanceReport",
  data() {
    return {
      loading: false,
      trialBalanceHtml: "",
      error: "",
    };
  },
  mounted() {
    this.fetchTrialBalance();
  },
  methods: {
    async fetchTrialBalance() {
      this.loading = true;
      this.error = "";
      try {
        const response = await GLAccountService.getTrialBalance();
        this.trialBalanceHtml = response.data.html;
      } catch (error) {
        this.error = "Failed to load trial balance report.";
        this.trialBalanceHtml = "";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
